import { createSelector } from 'reselect'

export const getRooms = createSelector(
    state => state.rooms,
    rooms => rooms
)

export function getRoom(state, props) {
    return state.rooms
}
export function getSettings(state, props) {
    return state.settings
}
export function getRoomsSuggest(state, props) {
    return state.roomssuggest
}

export function getRoomsFirstSuggest(state, props) {
    return state.roomsfirstsuggest
}

export function getSlots(state, props) {
    return state.slots
}

export function getFloors(state, props) {
    return state.floors
}

export function getRoomInfo(state, props) {
    return state.roomInfo
}

export function getform(state, props) {
    return state.form.searchSlots ? state.form.searchSlots.values : []
}

export function getAmenities(state, props) {
    return state.amenities
}

export function getRoomType(state, props) {
    return state.roomType
}

export function getFormSuggest(state, props) {
    return state.formSuggest
}

export function getFormSearchName(state, props) {
    return state.formSearchName
}


// WEBPACK FOOTER //
// ./src/features/rooms/selectors.js